module.exports = __webpack_public_path__ + "static/img/goods-1600.c62a12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s30/pop/goods-1600.png
// module id = As6f
// module chunks = 2